require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

exports = module.exports = typeof Object.keys === 'function' ? Object.keys : shim;
exports.shim = shim;

function shim(obj) {
  var keys = [];

  for (var key in obj) {
    keys.push(key);
  }

  return keys;
}